module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 1
// module chunks = 0